<script lang="ts">
import { defineComponent } from 'vue';
import router from '../../router';
import SolutoButton from '../../components/SolutoButton.vue';
import RadioButton from '../../components/RadioButton.vue';
import { mapActions, mapGetters } from 'vuex';

export default defineComponent({
  name: 'SurveyQ4',
  components: {
    RadioButton,
    Button: SolutoButton
  },
  data () {
    return {
      data: [
        { text: this.$t('level7'), key: '7' },
        { text: '6', key: '6' },
        { text: '5', key: '5' },
        { text: '4', key: '4' },
        { text: '3', key: '3' },
        { text: '2', key: '2' },
        { text: this.$t('level1'), key: '1' }
      ]
    };
  },
  computed: {
    ...mapGetters([
      'faqHelpfulnessScale',
      'isCallSurvey'
    ])
  },
  methods: {
    ...mapActions([
      'changeFaqHelpfulnessScale'
    ]),
    change (event: number) {
      this.changeFaqHelpfulnessScale(event);
    },
    nextScreen () {
      // If FAQ helpfulness scale is not 7, always go to question51
      if (this.faqHelpfulnessScale !== '7') {
        return router.push({ path: '/survey/question51/' });
      }

      // Otherwise, determine route based on survey type
      const nextPath = this.isCallSurvey
        ? '/survey/question10EnqRating/'
        : '/survey/question6/';

      router.push({ path: nextPath });
    },
    goBack () {
      router.go(-1);
    }
  }
});
</script>

<template>
  <div class="mainSurvey">
    <div class="q1">
          <p class="with-margin">{{ isCallSurvey ? $t('survey_04_01_call') : $t('survey_04_01') }}</p>
          <p class="with-margin">{{ isCallSurvey ? $t('survey_04_02_call') : $t('survey_04_02') }}</p>
          <radio-button :text="data" @change="change($event)" :value="faqHelpfulnessScale.toString()"/>
    </div>
    <div class="mainSurvey-footer">
      <Button
        class="footer-button"
        :size="'large'"
        :text="$t('previous')"
        :type="'outlined'"
        @click="goBack()"
      />
      <Button
        class="footer-button"
        :disabled="!faqHelpfulnessScale"
        :size="'large'"
        :text="$t('next')"
        @click="nextScreen()"
      />
    </div>
  </div>
</template>
